import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IInternalContactLead, internalContactLeadsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IByInternalContactLeadState } from './types';

const INTERNAL_CONTACT_LEAD_MODULE = 'internalContactLead';

const state: IByInternalContactLeadState = {
    byLead: new Map()
};

const dataObjectModule = getDataObjectsModule<IInternalContactLead>(internalContactLeadsManager, 3);
const searchModule = getSearchModule<IInternalContactLead>(internalContactLeadsManager);

const internalContactLeadModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions, state, getters, mutations });
store.registerModule(INTERNAL_CONTACT_LEAD_MODULE, internalContactLeadModuleInstance);

export { INTERNAL_CONTACT_LEAD_MODULE };
